<template lang="html">
  <div class="categories-wrapper">
    <div class="categories-title">
      <img src="@/assets/icons/bars.png" alt="categories icon">
      <span>{{$t('main.categories')}}</span>
    </div>
    <div class="categories">
      <div
        v-for="category in categories"
        :key="category.cat_id"
        class="category"
        >
        <div
          :class="{ active: category.open }"
          class="category-title"
          >
          <span :class="{ active: category.cat_id === active }" @click="openCategory(category)">{{category.cat_name}}</span>
          <div
            v-if="category.subCategories && category.subCategories.length> 0"
            @click="category.open = !category.open"
            class="dropdown-arrow-wrapper"
          >
            <img src="@/assets/icons/dropdownArrow.png" alt="dropdown arrow icon">
          </div>
        </div>
        <div
          v-if="category.subCategories && category.open"
          class="dropdown"
          >
          <div
            v-for="sub in category.subCategories"
            :key="sub.cat_id"
            @click="openCategory(sub)"
            class="sub"
            :class="{ active: sub.cat_id === active }"
            >
            <span>{{sub.cat_name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'categories',
  props: {
    categories: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    },
    active: {
      type: Number,
      required: false
    }
  },
  methods: {
    openCategory (category) {
      this.$emit('changeCategory', category)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/scrollbarStyles.scss';
.categories-wrapper {
  width: 264px;
  min-width: 264px;
  padding-top: 20px;
  padding-left: 20px;
  min-height: 150px;
  height: auto;
  position: relative;
  padding-bottom: 20px;
  margin-right: 24px;
  background: white;
  box-sizing: border-box;

  .categories-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    img {
      margin-right: 13px;
      margin-bottom: 1px;
      width: 16px;
      height: 12px;
    }
    span {
      text-transform: uppercase;
      color: #4F4F4F;
      font-weight: bold;
      font-size: 15px;
    }
  }
  .categories {
    position: absolute;
    width: calc( 100% - 20px );
    direction: rtl;
    overflow: auto;
    height: calc(100% - 80px);

    .category {
      direction:ltr;
      padding: 0 20px 0px 25px;

      .category-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        min-height: 30px;

        span {
          text-align: left;
          font-size: 13px;
          font-weight: 500;
          color: #797979;
          transition-duration: 0.2s;
          cursor: pointer;
        }
        span.active {
          color: $text-hover-color;
        }
        .dropdown-arrow-wrapper {
          width: 20px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          img {
            transition-duration: 0.2s;
          }
        }
      }
      .category-title:hover {
        span {
          color: $text-hover-color;
        }
      }
      .category-title.active {
        img {
          transform: rotate(180deg);
        }
        span {
          color: $text-hover-color;
        }
      }
      .dropdown {
        text-align: left;
        padding-left: 15px;
        padding-top: 7px;

        .sub {
          font-weight: normal;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.06em;
          color: #797979;
          margin-bottom: 5px;

          span {
            cursor: pointer;
            transition-duration: 0.2s;
          }
          span:hover {
            color: $text-hover-color;
          }
        }
        .sub.active {
          span {
            color: $text-hover-color;
          }
        }
      }
    }
  }
}
.small-nav-wrapper {
  .categories {
    position: relative !important;
  }
}
.slider-categories-wrapper {
  .categories {
    position: relative !important;
    max-height: 470px;
  }
}
</style>
